import { render, staticRenderFns } from "./cateAddStepper.vue?vue&type=template&id=00fc627b&scoped=true&"
import script from "./cateAddStepper.vue?vue&type=script&lang=js&"
export * from "./cateAddStepper.vue?vue&type=script&lang=js&"
import style0 from "./cateAddStepper.vue?vue&type=style&index=0&id=00fc627b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fc627b",
  null
  
)

export default component.exports